import { render, staticRenderFns } from "./scene11.vue?vue&type=template&id=4be20fbd&scoped=true&"
import script from "./scene11.vue?vue&type=script&lang=ts&"
export * from "./scene11.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be20fbd",
  null
  
)

export default component.exports